/** REF01 protocol 3.16: received letter fields 2.6–2.14 on a MedCom import. */

export const MEDCOM_RECEIVED_LOCK_KEYS = [
  'referral_diagnosis',
  'requested_examination',
  'anamnese',
  'sent_at',
  'ambulant',
  'cave',
  'examination',
  'actual_medicine',
  'attachments',
  'medcom_details',
  'referral_diagnosis_code',
] as const;

export type MedcomReceivedLockKey = (typeof MEDCOM_RECEIVED_LOCK_KEYS)[number];

export function isMedcomReceivedReferral(referral: {
  source?: string | null;
  medcom_type_code?: string | null;
}): boolean {
  return referral.source === 'medcom';
}

export function medcomLockedKeysInPayload(payload: Record<string, unknown>): MedcomReceivedLockKey[] {
  return MEDCOM_RECEIVED_LOCK_KEYS.filter((key) => Object.prototype.hasOwnProperty.call(payload, key));
}

export function omitMedcomLockedFields<T extends Record<string, unknown>>(
  payload: T,
): Omit<T, MedcomReceivedLockKey> {
  const next = { ...payload };
  for (const key of MEDCOM_RECEIVED_LOCK_KEYS) {
    delete next[key];
  }
  return next;
}
